module.exports = __webpack_public_path__ + "media/images/icons/icon-tee-d8a8c4f28cc587d6547a7ca58fdb92ad.svg";